import { MeasurementUnit } from '@casops/store/apis/settingsApi';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useMeasurementUnitOptions = (): DropdownItemProps<MeasurementUnit>[] => {
  const { t } = useTranslation();

  const items = useMemo(() => {
    return Object.values(MeasurementUnit).map((value: MeasurementUnit) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`MeasurementUnit.${value}`),
      };
    });
  }, [t]);

  return items;
};

export default useMeasurementUnitOptions;
